import React from 'react';
import { Chip } from '@mui/material';
import {
  ChatBubbleOutline as PromptIcon,
  HandymanOutlined as SkillIcon,
  SmartToyOutlined as AgentIcon,
} from '@mui/icons-material';
import {
  resolveCapabilityType,
  getCapabilityTypeLabel,
} from '../../constants/builderCategories';

const TYPE_ICONS = {
  prompt: PromptIcon,
  skill: SkillIcon,
  agent: AgentIcon,
};

export const capabilityTypeChipSx = {
  flexShrink: 0,
  height: 24,
  fontSize: '0.75rem',
  fontWeight: 500,
  color: 'text.secondary',
  borderColor: 'divider',
  bgcolor: 'grey.50',
  '& .MuiChip-icon': {
    color: 'text.secondary',
    ml: 0.5,
  },
  '& .MuiChip-label': {
    px: 1,
  },
};

export default function CapabilityTypeChip({
  capabilityType,
  size = 'small',
  showIcon = true,
  iconOnlyOnMobile = false,
  showNativeTitle = true,
  onClick,
  sx,
  ...rest
}) {
  const resolved = resolveCapabilityType(capabilityType);
  const Icon = TYPE_ICONS[resolved.value] || PromptIcon;
  const label = getCapabilityTypeLabel(capabilityType);

  return (
    <Chip
      label={label}
      size={size}
      variant="outlined"
      icon={showIcon ? <Icon sx={{ fontSize: '14px !important' }} /> : undefined}
      onClick={onClick}
      title={iconOnlyOnMobile && showNativeTitle ? label : undefined}
      aria-label={iconOnlyOnMobile ? label : undefined}
      sx={{
        ...capabilityTypeChipSx,
        ...(onClick ? { cursor: 'pointer' } : { pointerEvents: 'none' }),
        ...(iconOnlyOnMobile ? {
          pointerEvents: 'auto',
          width: { xs: 24, sm: 'auto' },
          minWidth: { xs: 24, sm: 'auto' },
          '& .MuiChip-icon': { color: 'text.secondary', ml: { xs: 0, sm: 0.5 }, mr: { xs: 0, sm: -0.5 } },
          '& .MuiChip-label': { display: { xs: 'none', sm: 'block' }, px: 1 },
        } : {}),
        ...sx,
      }}
      {...rest}
    />
  );
}

export { TYPE_ICONS };
